import { Checkbox as AntdCheckbox, Divider } from 'antd'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
const CheckboxGroup = AntdCheckbox.Group

const MultipleCheckBox = ({
  data,
  checkedList,
  setCheckedList,
  filterRequired = false,
}) => {
  const [indeterminate, setIndeterminate] = useState(true)
  const [checkAll, setCheckAll] = useState(false)
  const onChange = list => {
    setCheckedList(list)
    setIndeterminate(!!list.length && list.length < data.length)
    setCheckAll(list.length === data.length)
  }

  const onCheckAllChange = e => {
    let newCheckedList

    if (e.target.checked) {
      if (filterRequired) {
        newCheckedList = data
          ?.filter(option => !option.disabled)
          ?.map(option => option.value)
      } else {
        newCheckedList = data?.map(option => option.value)
      }
    } else {
      newCheckedList = []
    }

    setCheckedList(newCheckedList)
    setIndeterminate(false)
    setCheckAll(e.target.checked)
  }
  useEffect(() => {
    if (checkedList?.length) {
      if (checkedList?.length === data?.length) {
        setCheckAll(true)
        setIndeterminate(false)
        setCheckAll(true)
      }
    }
  }, [checkedList])
  const CustomWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
  `
  const StyledCheckbox = styled(AntdCheckbox)`
    .ant-checkbox + span {
      padding-right: 8px;
      padding-left: 8px;
      width: inherit;
    }
  `
  const StyledCheckBoxGroup = styled(CheckboxGroup)`
    display: contents;
    .ant-checkbox-group-item {
      margin-right: 8px;
      width: 100%;
    }
    .ant-checkbox + span {
      padding-right: 8px;
      padding-left: 8px;
      width: inherit;
    }
  `
  return (
    <React.Fragment>
      <StyledCheckbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        checked={checkAll}
      >
        Check all
      </StyledCheckbox>
      <Divider />
      <CustomWrapper>
        <StyledCheckBoxGroup
          options={data}
          value={checkedList}
          onChange={onChange}
        />
      </CustomWrapper>
    </React.Fragment>
  )
}
export default MultipleCheckBox
